import HeaderEvents from "./HeaderEvents";

export const changeMenu = (from: string, to: string, direction: string) => ({
    type: HeaderEvents.ChangeMenu,
    from, to, direction
} as const);
